import { render, staticRenderFns } from "./MenuComposableSquareBrick.vue?vue&type=template&id=0c896380&scoped=true&"
import script from "./MenuComposableSquareBrick.vue?vue&type=script&lang=js&"
export * from "./MenuComposableSquareBrick.vue?vue&type=script&lang=js&"
import style0 from "./MenuComposableSquareBrick.vue?vue&type=style&index=0&id=0c896380&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c896380",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c896380')) {
      api.createRecord('0c896380', component.options)
    } else {
      api.reload('0c896380', component.options)
    }
    module.hot.accept("./MenuComposableSquareBrick.vue?vue&type=template&id=0c896380&scoped=true&", function () {
      api.rerender('0c896380', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/MenuArea/MenuComposableSquareBrick.vue"
export default component.exports